webpackJsonp([4],{

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af5c79d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  methods: {}
});

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(289)(true);
// imports


// module
exports.push([module.i, ".about[data-v-af5c79d4]{width:100vw;min-height:100vh;padding-top:63px}.youtube-box[data-v-af5c79d4]{width:100vw;max-width:640px;height:75vw;max-height:360px;margin:auto;background:#ebebeb url(" + __webpack_require__(291) + ") no-repeat 50%;background-size:auto}", "", {"version":3,"sources":["/Users/tony/Desktop/projects/woods/src/components/About.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,iBAAkB,AAClB,gBAAkB,CACnB,AACD,8BACE,YAAa,AACb,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,+DAAgF,AAChF,oBAAsB,CACvB","file":"About.vue","sourcesContent":["\n.about[data-v-af5c79d4] {\n  width: 100vw;\n  min-height: 100vh;\n  padding-top: 63px;\n}\n.youtube-box[data-v-af5c79d4] {\n  width: 100vw;\n  max-width: 640px;\n  height: 75vw;\n  max-height: 360px;\n  margin: auto;\n  background: #ebebeb url('../../static/img/preload.gif') no-repeat center center;\n  background-size: auto;\n}\n/*styles for smaller screens*/\n@media (max-width: 767px) {\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(290)("07526880", content, true);

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('youtube', {
    staticClass: "youtube-box",
    attrs: {
      "video-id": 'KQOFL8GRdxQ',
      "player-width": "100%",
      "player-height": "100%"
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.86056940601aafa8c5aa.js